const actions = {
  GET_ALL_USERS: 'GET_ALL_USERS',
  SET_ALL_USERS: 'SET_ALL_USERS',
  GET_USER_DETAILS: 'GET_USER_DETAILS',
  SET_USER_DETAILS: 'SET_USER_DETAILS',
};

export default actions;
